import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutFakProfileLookup extends Layout {
    sourceFakProfileLookup: DataSource;
    tableFakProfile: Table;
}
